export enum FormFieldType {
	INPUT,
	SELECT,
	MASKED,
	MOMENT,
	ADDRESS
}

export const DATE_FORMATS = {
	parse: {
		dateInput: "L"
	},
	display: {
		dateInput: "L",
		monthYearLabel: "MMM YYYY",
		dateA11yLabel: "L",
		monthYearA11yLabel: "MMMM YYYY"
	}
};
